import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "./assets/styles/sass/variable.scss";
import i18n from "./system/lang/lang.js";
import VueCurrencyInput from 'vue-currency-input'
Vue.mixin({
  methods: {
    isFormObjectEmptyExcept(obj, excludeKeys = []) {
      if (!obj || typeof obj !== 'object') return true;

      return Object.entries(obj)
        .filter(([key]) => !excludeKeys.includes(key))
        .every(([, value]) => {
          if (value === null || value === undefined) return true;
          if (typeof value === 'string') return value.trim() === '';
          if (Array.isArray(value)) return value.length === 0;
          if (typeof value === 'object') return this.isFormObjectEmpty(value);
          return false;
        });
    },
    isAnyFormFieldFilled(form, ignoreFields = []) {
      return Object.entries(form).some(([key, value]) => {
        if (ignoreFields.includes(key)) return false;
        return value && value.toString().trim().length > 0;
      });
    },
    isFormFieldFilled(form, keys = []) {
      return keys.some(key => {
        const val = form[key]
        if (typeof val === 'string') return val.trim() !== ''
        if (typeof val === 'number') return val > 0
        return !!val
      })
    },

    isFormObjectEmpty(obj) {
      if (!obj || typeof obj !== 'object') return true;

      return Object.values(obj).every(v => {
        if (v === null || v === undefined) return true;
        if (typeof v === 'string') return v.trim() === '';
        if (Array.isArray(v)) return v.length === 0;
        if (typeof v === 'object') return this.isFormObjectEmpty(v);
        return false;
      });
    }
  }
});
Vue.config.productionTip = false

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
const pluginOptions = {
  globalOptions: {
    currency: 'MYR',
    locale: 'en-MY',
    distractionFree: false,
    autoDecimalMode: true,
    valueRange: { min: 0 },
    precision: 2
  }
}

Vue.use(VueCurrencyInput, pluginOptions)
import {
  getMemberInfo, getUserNewsList, country_list, getDownloadLink, getBannerList, getBankInfo,
} from "@/system/request/api/api";

new Vue({
  data() {
    return {
      isLoading: false,

      userInfo: {
        email: '',
        password2: null,
        invest: 0,
        country: {
          country_code: '',
        },
        user_group_id: 0,
        user_rank_id: 0,
        rank: {
          rank_name_en: ''
        },
        package: {
          id: '',
          price: 0,
        },
        point1: 0,
        point2: 0,
        point3: 0,
        point4: 0,
        max_cap: 1,
        current_progress: 0
      },
      globalInfo: {
        JABO_PRICE: '',
        WITHDRAW_FEE: '',
        WITHDRAW_MIN_AMOUNT: '',
      },
      bannerList: [],
      bankInfo: {
        bank_user: '',
        bank_number: '',
        bank_name: '',
      },
      unRead: '',
      newsItem: {
        description: ''
      },
      cryptoInfo: {},
      username: '',
      memberList: [],
      country_code: '',
      countryOptions: [],
      countryBankOptions: [],
      teamList: [],
      newsList: [],
      latestNews: [],
      variant: 'success',
      modal: {
        title: "",
        msg: "",
        action: false,
        error: false,
      },
      defaultCountry: {},
      errorImg: require('./assets/images/action/error.png')

    }
  },
  watch: {
    '$i18n.locale'() {
      this.getNewsList();
      this.getBannerList();
      this.getCountryList();
    },
  },
  methods: {
    processText(str) {
      let newStr = str.replace("Convert", this.$t('convert'));
      newStr = newStr.replace("Topup", this.$t('topup'));
      newStr = newStr.replace("Top Up", this.$t('topup'));

      let formatted = newStr.replace(/\d+(\.\d+)?/g, (match, _, offset, fullStr) => {
        const prevChar = fullStr[offset - 1] || "";
        const nextChar = fullStr[offset + match.length] || "";

        // Grab a slice before this number (up to 10 chars back)
        const beforeSlice = fullStr.slice(Math.max(0, offset - 10), offset);

        // 1. Skip if followed by %
        if (nextChar === "%") {
          return match;
        }

        // 2. Skip if directly touching letters/symbols (like J2025, USD2300, #1234)
        if (/[A-Za-z\p{L}\p{S}_]/u.test(prevChar) || /[A-Za-z\p{L}\p{S}_]/u.test(nextChar)) {
          return match;
        }

        // 3. Skip if it's a single small integer surrounded by spaces and letters (like "Jabo 1 Star")
        if (/^\d+$/.test(match) && parseInt(match) < 10) {
          const before = fullStr.slice(0, offset);
          const after = fullStr.slice(offset + match.length);
          if (/\p{L}\s*$/u.test(before) && /^\s*\p{L}/u.test(after)) {
            return match;
          }
        }

        // 4. Skip if preceded by "Level " (case-insensitive)
        if (/level\s*$/i.test(beforeSlice)) {
          return match;
        }

        // ✅ 5. Otherwise, format with decimals
        return parseFloat(match).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      });

      return formatted;
    }
    ,
    getPackageLevel(str) {
      var rank = str.match(/\d+/);
      if (rank != null)
        return parseInt(rank[0]);
      else
        return 0;
    },
    parseFloatCustom(num) {
      return parseFloat(num).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
    changeLan(lan) {
      localStorage.setItem('lan', lan);
      this.$i18n.locale = lan;
    },
    getCountryList() {
      var self = this;
      self.countryOptions = [];
      self.countryBankOptions = [];
      this.isLoading = true;
      var result = country_list();
      result
        .then(function (value) {
          self.$root.isLoading = false;
          var rootDataList = value.data.data;

          for (let i = 0; i < rootDataList.length; i++) {
            rootDataList[i]["symbol"] = rootDataList[i].short_form;
            rootDataList[i]["value"] = rootDataList[i].id;
            rootDataList[i]["code"] = rootDataList[i].country_code;
            rootDataList[i]["rate"] = rootDataList[i].sell;
            rootDataList[i]["name"] = self.$i18n.locale == 'zh' ? rootDataList[i].name : rootDataList[i].name_en;

            self.countryOptions.push(rootDataList[i]);
          }
          self.defaultCountry = rootDataList.find(el => el.id == 2);
          self.countryBankOptions.push(self.defaultCountry);

          self.countryOptions = Array.from(
            new Map(self.countryOptions.map(item => [item.value, item])).values()
          );

          const priorityCountries = ["Malaysia", "Singapore", "Brunei", "Indonesia", "Thailand", "Vietnam", "China"];
          self.countryOptions.sort((a, b) => {
            const indexA = priorityCountries.indexOf(a.name_en);
            const indexB = priorityCountries.indexOf(b.name_en);

            if (indexA === -1 && indexB === -1) return 0;
            if (indexA === -1) return 1;
            if (indexB === -1) return -1;
            return indexA - indexB;
          });

          console.log('countryOptions:', self.countryOptions);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getGlobalSetting() {
      var result = getDownloadLink();
      var self = this;
      this.isLoading = true;
      result
        .then(function (value) {
          self.isLoading = false;
          self.globalInfo = value.data.data.system;
          console.log(self.globalInfo.YESTERDAY_USD);
        })
        .catch(function () {
          self.isLoading = false;
        });
    },
    getInfo() {
      var self = this;
      self.isLoading = true;
      self.$root.userInfo = {
        username: '',
        password2: null,
        invest: 0,
        country: {
          country_code: '',
        },
        user_group_id: 0,
        rank: {
          rank_name_en: ''
        },
        package: {
          price: 0,
        },
        point1: 0,
        point2: 0,
        point3: 0,
        point4: 0,
        max_cap: 1,
        current_progress: 0
      };
      var result = getMemberInfo();
      result
        .then(function (value) {
          self.isLoading = false;
          self.userInfo = value.data.data;
          if (self.userInfo.max_cap == 0) {
            self.userInfo.max_cap = 1;
          }
          if (self.userInfo.password2 == null) {
            self.$router.push('/web/set-sec-password')

          }
          if (self.userInfo.google_lock == 0) {
            self.$bvModal.show('modal-setupGA');

          }

        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getBankInfo() {
      var result = getBankInfo();
      var self = this;

      result.then(function (value) {
        if (value.data.data != null) {
          self.bankInfo = value.data.data;

          self.defaultCountry = self.countryOptions.find(el => el.id == self.bankInfo.bank_country);
        }

      }).catch(function () {
      });
    },
    // getCInfo() {
    //   var result = getCryptoInfo();
    //   var self = this;
    //   result
    //     .then(function (value) {
    //       if (value.data.data != null) {
    //         self.cryptoInfo = value.data.data;
    //       }

    //     })
    //     .catch(function () { });
    // },
    getBannerList() {
      // this.$i18n.locale == 'zh' ? 'cn' : 'en'
      this.bannerList = [];
      var result = getBannerList(this.$i18n.locale == 'zh' ? 'cn' : 'en', 2, 1);
      var self = this;
      result
        .then(function (value) {

          self.bannerList = value.data.data;
          console.log(self.bannerList);


        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getNewsList() {
      var result = getUserNewsList(this.$i18n.locale == 'zh' ? 'cn' : this.$i18n.locale, 1, 1);
      var self = this;
      result
        .then(function (value) {
          self.newsList = value.data.data.record.data;
          self.unRead = value.data.data.unread;
          self.latestNews = value.data.data.latest;
          if (self.latestNews.length > 0) {
            var date = localStorage.getItem('dunShow');
            var today = new Date().getDate();
            if (date != today) {
              self.$bvModal.show('modal-news');

            }

          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    makeToast(type, title, msg = '') {
      const h = this.$createElement;

      const iconMap = {
        success: require('./assets/images/action/success.png'),
        danger: require('./assets/images/action/error.png'),
        warning: require('./assets/images/action/error.png'),
        info: require('./assets/images/action/info.png'),
      };

      const icon = iconMap[type] || iconMap.info;

      this.$bvToast.toast(
        [
          h('div', { class: 'd-flex align-items-center' }, [
            h('img', {
              attrs: {
                src: icon,
                height: '32px',
                width: '32px',
                class: 'mr-2 mt-1',
              },
            }),
            h('div', { class: 'd-flex flex-column justify-content-center' }, [
              h('div', { class: '' }, title),
              msg ? h('div', msg) : null,
            ]),
          ]),
        ],
        {
          variant: type,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000,
          appendToast: false,
          noCloseButton: true,
          toastClass: 'no-toast-header custom-toast-style',
        }
      );
    },

    checkKYC() {
      if (this.userInfo.check_kyc.can_withdraw == 'approved') {
        this.$bvModal.show('withdraw');

      } else {
        this.modal = {
          title: this.$t('kyc'),
          msg: this.$t('kyc_hint'),
          action: false,
          error: true,
        };
        this.$bvModal.show('modal-errorMsg');

      }
    },
    clearErrorMsg() {
      this.$root.modal = {
        title: "",
        msg: "",
        action: false,
        error: false,
      };
      this.errorImg = require('./assets/images/action/error.png');

    },
    updatePb() {
      var heighest = 0;
      var bottom = document.getElementsByClassName('withdraw-hint');
      var mainContent = document.getElementsByClassName('main-content');
      if (mainContent) {
        mainContent = mainContent[0];
        if (bottom) {
          for (let i = 0; i < bottom.length; i++) {
            if (bottom[i].offsetHeight > heighest) {
              heighest = bottom[i].offsetHeight;
              console.log(heighest);

            }
          }
        }
        if (mainContent)
          mainContent.setAttribute('style', 'padding-bottom:' + (heighest + 100) + 'px !important');


      }
    }
  },
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
